import { useEffect, useState } from "react";
import { apiClient } from "../../../apiclient/apiclient";

const SalesSummary = ({ range = "7days" }) => {
  const [trend, setTrend] = useState([]);
  const [loading, setLoading] = useState(true);

  /* -----------------------------
     Range label mapping
  ------------------------------ */
  const RANGE_LABELS = {
    "7days": "last 7 days",
    month: "this month",
    year: "this year",
  };

  /* -----------------------------
     Fetch sales trend (single source)
  ------------------------------ */
  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);
        const res = await apiClient.get(
          `/sales-trend?range=${range}&metric=sales`,
        );
        setTrend(res.data || []);
      } catch (err) {
        console.error("Failed to load sales summary", err);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [range]);

  /* -----------------------------
     Loading state
  ------------------------------ */
  if (loading) {
    return (
      <div className="rounded-xl p-6 w-full h-full animate-pulse bg-gradient-to-r from-indigo-100 via-blue-100 to-cyan-100">
        <div className="h-20 bg-white/40 rounded-md" />
      </div>
    );
  }

  /* -----------------------------
     Total Sales (CORRECT)
  ------------------------------ */
  const totalSales = trend.reduce((sum, item) => sum + (item.sales || 0), 0);

  /* -----------------------------
     UI
  ------------------------------ */
  return (
    <div className="relative overflow-hidden rounded-none p-6 w-full h-full bg-gradient-to-br from-orange-400 to-amber-700 text-white flex flex-col justify-between min-h-[220px]">
      {/* GLASS BLUR EFFECT */}
      <div className="absolute inset-0 bg-white/10 blur-3xl rounded-full -top-20 -left-20 w-64 h-64"></div>
      <div className="absolute inset-0 bg-white/5 blur-2xl rounded-full -bottom-10 -right-10 w-48 h-48"></div>

      {/* Header */}
      <div className="relative z-10 text-[10px] font-bold uppercase opacity-80 tracking-[0.2em] mb-2">
        Total Sales Overview
      </div>

      {/* Centered Total */}
      <div className="relative z-10 flex-1 flex items-center justify-center">
        <div className="text-center w-full">
          <div className="text-4xl md:text-5xl font-black italic leading-tight tracking-tighter break-words w-full drop-shadow-lg">
            ₹{new Intl.NumberFormat("en-IN").format(totalSales)}
          </div>
          {/* Range text */}
          <div className="text-[11px] font-bold opacity-70 mt-3 uppercase tracking-widest bg-white/10 inline-block px-3 py-1 rounded-full border border-white/10 backdrop-blur-sm">
            in {RANGE_LABELS[range]}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SalesSummary;
